import React, { useContext, useState, useEffect, useRef } from "react";
import {
  Container,
  customStyles,
  NextButton,
  DataSelect,
  SelectWrapper,
} from "./dropDown.styles";
import CurrentQuestionContext from "../../../contexts/CurrentQuestionContext";
import Select from "react-select";

const DropDown = () => {
  const setNextQuestion = useContext(CurrentQuestionContext).setNextQuestion;
  const [selectedOption, setSelectedOption] = useState(null);
  const [options, setOptions] = useState([]);
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const question = useContext(CurrentQuestionContext).question;
  const currQuestionIndex = useContext(CurrentQuestionContext)
    .currQuestionIndex;
  let inputEl = useRef(null);
  let startTime = new Date();

  useEffect(() => {
    setSelectedOption(null);
    setOptions(question.values.map((x) => ({ value: x, label: x })));
  }, [currQuestionIndex]);

  const openMenu = () => {
    setMenuIsOpen(true);
    inputEl.focus();
    //to do open react select menu
  };

  const closeMenu = () => {
    setMenuIsOpen(false);
    //to do close react select menu
  };

  return (
    <Container menuIsOpen={menuIsOpen}>
      {question.allowToUseKeyboard ? (
        <Select
          ref={(node) => (inputEl = node)}
          value={selectedOption}
          onChange={(x) => {
            inputEl.blur();
            setSelectedOption(x);
            setMenuIsOpen(false);
          }}
          options={options}
          styles={customStyles}
          isRtl
          onFocus={openMenu}
          onBlur={closeMenu}
          placeholder={question.placeHolder}
          isSearchable={true}
          menuIsOpen={menuIsOpen}
        />
      ) : (
        <SelectWrapper>
          <DataSelect onChange={(x) => setSelectedOption(x)}>
            {options.map((x) => (
              <option value={x.value} key={x}>
                {x.label}
              </option>
            ))}
          </DataSelect>
        </SelectWrapper>
      )}
      <NextButton
        isDisabled={selectedOption === null}
        onClick={() => {
          if (selectedOption)
            setNextQuestion(selectedOption.value, new Date() - startTime);
        }}
      >
        לשאלה הבאה
      </NextButton>
    </Container>
  );
};

export default DropDown;
